import lodash from 'lodash'
const defaultComponentObj = {
  customTextCard: {
    componentName: 'customTextCard',
    itemId: 'free-custom-card',
    heading: '',
    data: {
      text: ''
    }
  },
  histories: {
    date: {
      year: '',
      month: ''
    },
    termDate: {
      year: '',
      month: ''
    },
    desc: ''
  },
  licencies: {
    name: ''
  },
  stakeholders: {
    name: '',
    address: '',
    shareRate: 0,
    salesOnCreditRate: 0,
    closingAndPayment: '月末締め・翌月末払い'
  },
  borrowers: {
    name: '',
    howUse: '',
    amount: '	',
    repaymentAtYear: ''
  },
  positions: {
    kind: '',
    number: 0,
    detail: ''
  }
}

function getDefaultComponentObj(componentName) {
  return _.cloneDeep(defaultComponentObj[componentName])
}

export default getDefaultComponentObj
